import React, { useState } from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

import Sticky from 'react-sticky-el'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

// components
import BlocksHeader from '@/components/optypes/frontend/StickyScroller/BlocksHeader'

import ReactPlayer from 'react-player'

// blocks
import Header from '@/components/optypes/frontend/SideScroller/blocks/Header'
import InputBlock from '@/components/optypes/frontend/SideScroller/blocks/InputBlock'
import ButtonBlock from '@/components/optypes/frontend/SideScroller/blocks/ButtonBlock'
import MultiChoiceBlock from '@/components/optypes/frontend/SideScroller/blocks/MultiChoiceBlock'
import LinkBlock from '@/components/optypes/frontend/SideScroller/blocks/LinkBlock'

import dynamic from 'next/dynamic'

// drag and drop context wrapper
import DragWrapper from '@/components/optypes/headlesss-components/DragWrapper'
import OnepagerFooter from '@/components/optypes/headlesss-components/OnepagerFooter'

const CardsBlock = dynamic(
  () => import('@/components/optypes/frontend/SideScroller/blocks/CardsBlock'),
  {
    ssr: false,
  }
)

const TodosBlock = dynamic(
  () => import('@/components/optypes/frontend/SideScroller/blocks/TodosBlock'),
  {
    ssr: false,
  }
)

const Scrollbars = dynamic(() => import('react-custom-scrollbars'), {
  ssr: false,
})

const Components = {
  header: Header,
  inputblock: InputBlock,
  cardblock: CardsBlock,
  todosblock: TodosBlock,
  ctablock: ButtonBlock,
  multichoiceblock: MultiChoiceBlock,
  linkblock: LinkBlock,
}

const SideScroller = () => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  const [fullScreen, setFullScreen] = useState(false)

  return (
    <div
      className=""
      style={{
        backgroundColor: returnValue('pagebg', opDesign, pageDesign),
      }}
    >
      <div
        className="relative shadow-lg z-20"
        style={{
          backgroundColor: returnValue(
            'blockheaderbgcolor',
            opDesign,
            pageDesign
          ),
          color: returnValue('blockheadertextcolor', opDesign, pageDesign),
        }}
      >
        <div className=" px-12 mx-auto">
          <BlocksHeader />
        </div>
      </div>

      {/* wrapper */}
      <div
        className="overflow-y-auto mainWrapper"
        style={{
          height: builder ? 'calc(100vh - 8rem)' : 'calc(100vh - 4rem)',
        }}
      >
        {/* HEADER */}
        <div
          className={Classnames(
            ' border-b-2 border-black border-opacity-25 relative z-10'
          )}
          style={{
            backgroundColor: returnValue('bgcolor', opDesign, pageDesign),
            color: returnValue('maintextcolor', opDesign, pageDesign),
          }}
        >
          {/* background image */}
          {returnValue('bgimgurl', opDesign, pageDesign) && (
            <div
              className="absolute top-0 left-0 z-0 h-full w-full  bg-cover bg-no-repeat"
              style={{
                backgroundImage: `url(${returnValue(
                  'bgimgurl',
                  opDesign,
                  pageDesign
                )})`,
                opacity: returnValue('bgimgopacity', opDesign, pageDesign),
              }}
            ></div>
          )}

          <div className="px-12 mx-auto">
            <div className="flex items-center relative z-0 pt-20 pb-0">
              <div className="w-1/3">
                {/* video */}
                {/* {returnValue('videourl', opStatic, pageStatic) && (
                  <Sticky className="transition" scrollElement=".mainWrapper">
                    <div className="pt-6 mb-12">
                      <div className="player-wrapper rounded shadow-lg overflow-hidden">
                        <ReactPlayer
                          controls={false}
                          playing={false}
                          width="100%"
                          height="100%"
                          className="react-player"
                          url={returnValue('videourl', opStatic, pageStatic)}
                        />
                      </div>
                    </div>
                  </Sticky>
                )} */}

                {returnValue('videourl', opStatic, pageStatic) && (
                  <div
                    className={Classnames(
                      'pt-6 mb-12 fixed w-1/3 pr-8 top-16',
                      {
                        'top-16': !builder,
                        'top-32': builder,
                      }
                    )}
                  >
                    <div className="player-wrapper rounded shadow-lg overflow-hidden">
                      <ReactPlayer
                        controls={false}
                        playing={false}
                        width="100%"
                        height="100%"
                        className="react-player"
                        url={returnValue('videourl', opStatic, pageStatic)}
                      />
                    </div>
                  </div>
                )}

                {/* img */}
                {/* {returnValue('imgurl', opStatic, pageStatic) && (
                  <Sticky
                    className="transition"
                    onFixedToggle={true}
                    scrollElement=".mainWrapper"
                  >
                    <div className="pt-6 mb-12">
                      <img
                        src={returnValue('imgurl', opStatic, pageStatic)}
                        alt=""
                        className="rounded shadow-lg mb-8"
                      />
                    </div>
                  </Sticky>
                )} */}

                {/* img */}
                {returnValue('imgurl', opStatic, pageStatic) && (
                  <div className="pt-6 mb-12 fixed w-1/3 pr-8 top-16">
                    <img
                      src={returnValue('imgurl', opStatic, pageStatic)}
                      alt=""
                      className="rounded shadow-lg mb-8"
                    />
                  </div>
                )}
              </div>

              {/* headline / subheadline */}
              <div className="w-2/3 pl-12 mb-20">
                <h1
                  className={Classnames('font-bold text-6xl', {
                    appTitleItem:
                      returnValue('herofont', opDesign, pageDesign) == 'sans',
                  })}
                  style={{
                    color: returnValue(
                      'headlinetextcolor',
                      opDesign,
                      pageDesign
                    ),
                  }}
                >
                  <StaticContentWrapper contentKey="headline">
                    {returnValue('headline', opStatic, pageStatic)}
                  </StaticContentWrapper>
                </h1>
                <div className="mt-4 mb-6 text-xl font-medium">
                  <StaticContentWrapper contentKey="subheadline">
                    {returnValue('subheadline', opStatic, pageStatic)}
                  </StaticContentWrapper>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* side scroller content blocks */}
        <div
          className={Classnames(
            '  px-12 pr-8 -mt-12 relative z-20 flex justify-end',
            {}
          )}
          style={
            {
              // backgroundColor: returnValue('blockbgcolor', opDesign, pageDesign),
              // color: returnValue('blocktextcolor', opDesign, pageDesign),
            }
          }
        >
          {/* <div className="w-1/2"></div> */}
          <div className="space-y-4 w-2/3 pl-12 pr-0">
            <DragWrapper>
              {pageBlocks.map((block, index) => (
                <BlockRenderer
                  key={index}
                  index={index}
                  Components={Components}
                  block={block}
                />
              ))}
            </DragWrapper>

            {/* add block button builder */}
            {builder && <AddBlockBuilder btnText="Add Block" />}
          </div>
        </div>
        <div
          className="py-12"
          style={
            {
              // color: returnValue('maintextcolor', opDesign, pageDesign),
            }
          }
        >
          <OnepagerFooter />
        </div>
      </div>
    </div>
  )
}

export default SideScroller
